import $ from 'jquery';

$(function () {
    var $grid = $('[data-studien-grid]');
    if (!$grid.length) return;

    var $items = $grid.find('.studien--item');
    var $noResults = $('.studien--no-results');
    var $search = $('#studien-search-input');
    var $clear = $('#studien-search-clear');

    var active = {
        tumor: new Set(),
        typ: new Set(),
        phase: new Set(),
        standort: new Set(),
        erkrankung: new Set(),
    };
    var query = '';
    var searchTimeout = null;

    function getValues($item, group) {
        var raw = ($item.attr('data-' + group) || '').trim();
        if (!raw) return [];
        return raw.split(/\s+/);
    }

    function hasActiveFilters() {
        if (query !== '') return true;

        var groups = Object.keys(active);
        for (var i = 0; i < groups.length; i++) {
            if (active[groups[i]].size > 0) return true;
        }
        return false;
    }

    function updateResultsTitle(visible) {
        var $wrap = $('.studien--results--title');
        if (!$wrap.length) return;

        var defaultCountTpl = String($wrap.data('default-count-label') || '');
        var countTpl = String($wrap.data('count-label') || '%d results');
        var $title = $wrap.find('h3');

        if (hasActiveFilters()) {
            $title.text(countTpl.replace('%d', String(visible)));
        } else if (defaultCountTpl) {
            $title.text(defaultCountTpl.replace('%d', String($items.length)));
        } else {
            $title.text(String($wrap.data('default-title') || ''));
        }
    }

    function matchesStandortFilter($item, values) {
        var itemSpital = String($item.attr('data-spital') || '');
        var itemKlinik = String($item.attr('data-klinik') || '');

        for (var value of values) {
            var parts = String(value).split(':');
            if (parts.length < 2) continue;

            var type = parts[0];
            var slug = parts.slice(1).join(':');

            if (type === 'spital' && itemSpital === slug) return true;
            if (type === 'klinik' && itemKlinik === slug) return true;
        }

        return false;
    }

    function applyFilters() {
        var visible = 0;
        $items.each(function () {
            var $item = $(this);
            var match = true;

            // OR within a group, AND across groups
            var groups = Object.keys(active);
            for (var i = 0; i < groups.length; i++) {
                var g = groups[i];
                if (active[g].size === 0) continue;

                if (g === 'standort') {
                    if (!matchesStandortFilter($item, active[g])) {
                        match = false;
                        break;
                    }
                    continue;
                }

                var values = getValues($item, g);
                var hit = false;
                for (var j = 0; j < values.length; j++) {
                    if (active[g].has(values[j])) { hit = true; break; }
                }
                if (!hit) { match = false; break; }
            }

            if (match && query !== '') {
                var searchBlob = ($item.attr('data-search') || '');
                if (searchBlob.indexOf(query) === -1) match = false;
            }

            if (match) {
                $item.show();
                visible++;
            } else {
                $item.hide();
            }
        });

        if (visible === 0) {
            $noResults.show();
            $grid.hide();
        } else {
            $noResults.hide();
            $grid.show();
        }

        updateResultsTitle(visible);
    }

    function toggleClearButton() {
        if ($search.val() && $search.val().length > 0) {
            $clear.show();
        } else {
            $clear.hide();
        }
    }

    function setGroupFilter(group, value) {
        active[group].clear();
        if (value) {
            active[group].add(value);
        }
        applyFilters();
    }

    function updateBadgesDropdownLabel() {
        var $dropdown = $('.studien--dropdown--badges');
        if (!$dropdown.length) return;

        var placeholder = String($dropdown.data('placeholder') || '');
        var selectedTpl = String($dropdown.data('selected-label') || '%d selected');
        var count = active.erkrankung.size;
        var $valueEl = $dropdown.find('.studien--dropdown__value');

        if (count === 0) {
            $valueEl.text(placeholder);
            $dropdown.removeClass('has-value');
            return;
        }

        $dropdown.addClass('has-value');
        if (count === 1) {
            var value = active.erkrankung.values().next().value;
            var $btn = $('.post-button[data-filter-group="erkrankung"][data-filter-value="' + value + '"]').first();
            $valueEl.text($btn.text().trim());
            return;
        }

        $valueEl.text(selectedTpl.replace('%d', String(count)));
    }

    $(document).on('click', '.post-button[data-filter-group="erkrankung"]', function (e) {
        e.preventDefault();
        var value = String($(this).data('filter-value'));
        var $buttons = $('.post-button[data-filter-group="erkrankung"][data-filter-value="' + value + '"]');
        var isActive = $buttons.first().hasClass('active');

        if (isActive) {
            $buttons.removeClass('active');
            active.erkrankung.delete(value);
        } else {
            $buttons.addClass('active');
            active.erkrankung.add(value);
        }

        applyFilters();
        updateBadgesDropdownLabel();
    });

    function closeStudienDropdowns($except) {
        $('.studien--dropdown.is-open').not($except).each(function () {
            var $dropdown = $(this);
            $dropdown.removeClass('is-open');
            $dropdown.find('.studien--dropdown__toggle').attr('aria-expanded', 'false');
            $dropdown.find('.studien--dropdown__menu').prop('hidden', true);
        });
    }

    function setDropdownDisplay($dropdown, value, label) {
        var placeholder = String($dropdown.data('placeholder') || '');
        var $valueEl = $dropdown.find('.studien--dropdown__value');

        $dropdown.attr('data-value', value);
        $dropdown.toggleClass('has-value', value !== '');

        if (value) {
            $valueEl.text(label);
        } else {
            $valueEl.text(placeholder);
        }

        $dropdown.find('.studien--dropdown__option').removeClass('is-selected').attr('aria-selected', 'false');
        $dropdown.find('.studien--dropdown__option').filter(function () {
            return String($(this).attr('data-value') || '') === value;
        })
            .addClass('is-selected')
            .attr('aria-selected', 'true');
    }

    $(document).on('click', '.studien--dropdown', function (e) {
        if ($(e.target).closest('.studien--dropdown__close').length) {
            e.preventDefault();
            closeStudienDropdowns();
            return;
        }
    });

    $(document).on('click', '.studien--dropdown__toggle', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $dropdown = $(this).closest('.studien--dropdown');
        var isOpen = $dropdown.hasClass('is-open');

        closeStudienDropdowns();

        if (!isOpen) {
            $dropdown.addClass('is-open');
            $(this).attr('aria-expanded', 'true');
            $dropdown.find('.studien--dropdown__menu').prop('hidden', false);
        }
    });

    $(document).on('click', '.studien--dropdown__option', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $option = $(this);
        var $dropdown = $option.closest('.studien--dropdown');
        var group = String($dropdown.attr('data-filter-group') || '');
        var value = String($option.attr('data-value') || '');
        var label = $option.text().trim();

        if (!group || !(group in active)) return;

        setDropdownDisplay($dropdown, value, label);
        setGroupFilter(group, value);
        closeStudienDropdowns();
    });

    $(document).on('click', function (e) {
        if ($(e.target).closest('.studien--dropdown').length) return;
        closeStudienDropdowns();
    });

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape') {
            closeStudienDropdowns();
        }
    });

    function runSearch() {
        var v = $search.val() || '';
        query = v.toString().toLowerCase().trim();
        applyFilters();
    }

    $search.on('input keyup', function () {
        toggleClearButton();
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(runSearch, 150);
    });

    $search.on('keydown', function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            clearTimeout(searchTimeout);
            toggleClearButton();
            runSearch();
        }
    });

    $clear.on('click', function (e) {
        e.preventDefault();
        $search.val('');
        $clear.hide();
        query = '';
        applyFilters();
    });

    $(document).on('click', '.title--switch__lang', function () {
        var lang = $(this).data('lang');
        var $title = $(this).closest('.studien--title');
        if (!$title.length || !lang) return;

        $title.attr('data-lang', lang);
        $title.find('.title--switch__lang')
            .removeClass('is-active')
            .addClass('text-dark font-normal');
        $(this)
            .addClass('is-active')
            .removeClass('text-dark font-normal');
    });

    $(document).on('keydown', '.title--switch__lang', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).trigger('click');
        }
    });
});
